import { Component, EventEmitter, Input, Output } from '@angular/core';

import { NavigationConfiguration } from '@zipari/shared-ds-util-navigation';

@Component({
  selector: 'nav-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.scss'],
})
export class ContactUsComponent {
  @Input() config: NavigationConfiguration;
  @Input() isOpen: boolean;

  @Output() closeButtonClicked = new EventEmitter<void>();

  close() {
    this.closeButtonClicked.emit();
  }
}
